export type EnquiryData = {
    _id?: string;
    dateOfEnquiry?: string;
    institutionName?: string;
    enquiryPurpose?: string;
    enquiryAmount?: string;
    tenure?: string;
    directorId?: string;
    assesseeId?: string;
};

export type BureauEnquiryTableProps = {
    data: EnquiryData[];
    loading: boolean;
    vendorType: VendorType;
};

export type VendorType = 'EQUIFAX' | 'EXPERIAN' | 'TRANSUNION';

// Bureau-type enum-like constant. Use BureauType.X instead of inline string literals
// for type-safety + grep-ability. Includes ALL (the "no specific bureau" filter value)
// alongside the three real bureaus.
export const BureauType = {
    EQUIFAX: 'EQUIFAX',
    EXPERIAN: 'EXPERIAN',
    TRANSUNION: 'TRANSUNION',
    ALL: 'All',
} as const;
export type BureauTypeValue = (typeof BureauType)[keyof typeof BureauType];

export const NEW_TO_CREDIT_THRESHOLD = 100;

// Maximum possible bureau score (denominator for the score progress bars).
export const MAX_BUREAU_SCORE = 900;
